import {
  Stack,
  Heading,
  Card,
  IconChevron,
  Text,
  Strong,
  Box,
  ButtonLink,
  TextLink,
} from 'braid-design-system';

import Routes from 'src/config/routes';
import type { ListingProduct } from 'src/generated/graphql';
import { clearSelectedProduct } from 'src/utils/cookies';

import { Features } from './components/Features/Features';

interface SelectedProductProps {
  listingId: string;
  product: ListingProduct;
}

export const SelectedProduct = (props: SelectedProductProps) => (
  <Stack space="none">
    <Card>
      <Stack space="xlarge">
        <Heading level="2">Success!</Heading>

        <Stack space="medium">
          <Heading level="4">
            You chose a <Strong>{props.product.description}</Strong>
          </Heading>

          <Features product={props.product} />

          <Box paddingLeft="medium">
            <Stack space="medium">
              <Text>or</Text>

              <Text>
                <TextLink
                  href={createPackagesLink(props.listingId)}
                  onClick={() => clearSelectedProduct()}
                >
                  Pick another ad pack <IconChevron direction="right" />
                </TextLink>
              </Text>
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Card>

    <ButtonLink
      href={createPaymentLink(props.listingId, props.product.productToken)}
    >
      Next - payment <IconChevron direction="right" />
    </ButtonLink>
  </Stack>
);

const createPaymentLink = (listingId: string, productToken: string) => {
  const searchParams = new URLSearchParams();
  searchParams.set('listingId', listingId);
  searchParams.set('productToken', productToken);
  return `${Routes.PAYMENT}?${searchParams.toString()}`;
};

const createPackagesLink = (listingId: string) => {
  const searchParams = new URLSearchParams();
  searchParams.set('listingId', listingId);
  return `${Routes.PACKAGES}?${searchParams.toString()}`;
};
